// Configuration types
export const FETCH_CONFIGURATION_START = "FETCH_CONFIGURATION_START";
export const FETCH_CONFIGURATION_SUCCESS = "FETCH_CONFIGURATION_SUCCESS";
export const FETCH_CONFIGURATION_ERROR = "FETCH_CONFIGURATION_ERROR";
export const UPDATE_RATES_START = "UPDATE_RATES_START";
export const UPDATE_RATES_SUCCESS = "UPDATE_RATES_SUCCESS";
export const UPDATE_RATES_ERROR = "UPDATE_RATES_ERROR";
